<template>
  <span class="merchant-preload">
    <content-loader
      :height="215"
      :width="160"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="0" y="16" rx="5" ry="5" width="160" height="160" />
      <rect x="20" y="195" rx="5" ry="5" width="120" height="20" />
    </content-loader>
  </span>
</template>

<script>
export default {
  name: "MerchantPreload"
};
</script>

<style lang="scss">
.merchant-preload {
  display: block;
}
.merchant-preload,
.merchant-preload svg {
  height: 193px;
  width: 100%;
  max-width: 140px;
}
</style>
